<template>
    <NoButtonModal :open="true">
        <button class="close-corner-x" type="button" @click.prevent="alertResponse('cancel')">
            <span class="material-icons-outlined dark-text">close</span>
        </button>

        <div v-if="!loading">
            <h1>Delete Alert</h1>
            <p v-if="$route.query.id">Are you sure you want to delete this key/value?</p>
            <p v-else>Are you sure you want to delete this Lookup Table?</p>
            <p v-if="indexTodelete && dashboardCount <= 1">This table is linked with {{ dashboardCount }} dashboard</p>
            <p v-else-if="indexTodelete">This table is linked with {{ dashboardCount }} dashboards</p>
            <button @click="alertResponse('cancel')" class="button secondary">Cancel</button>
            <button @click="alertResponse('handleDelete')" class="button primary">Delete</button>
        </div>

        <div
            v-if="loading"
            class="d-flex flex-column justify-content-center align-items-center loader-main"
            style="min-height: 12rem"
        >
            <b-spinner variant="primary" class="add-list-function-loader mb-1"></b-spinner>
            <span class="ms-3">Loading ...</span>
        </div>
    </NoButtonModal>
</template>

<script>
    import NoButtonModal from '@/components/general/modals/NoButtonModal';
    import { lookupTable } from '../../util/apiRequests';

    export default {
        name: 'DeleteLookupTable',
        components: { NoButtonModal },
        data() {
            return {
                loading: true,
                dashboardCount: 0,
            };
        },
        props: {
            indexTodelete: {
                type: Number,
            },
        },
        methods: {
            async getDashboardCount() {
                let response = await this.$api.get(lookupTable.getDashboardCount(this.indexTodelete));
                if (response?.data?.dashboard_count) {
                    this.dashboardCount = response?.data?.dashboard_count;
                }
            },
            alertResponse(action) {
                if (action === 'handleDelete') {
                    this.$emit('handleDelete');
                } else {
                    this.$emit('cancel');
                }
            },
        },
        async created() {
            if (this.indexTodelete) {
                await this.getDashboardCount();
            }
            this.loading = false;
        },
    };
</script>
